import config from "../config"
const baseUrl = config.base_url + "data_processor/"
export default {
    list: {
        url: baseUrl + "list",
        type: "get",
    },
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    get: {
        url: baseUrl + "detail",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    execute: {
        url: baseUrl + "execute",
        type: "get",
    }
}

